import Icon from '@/components/UI/icon/Icon';
import { IconNames } from '@/components/UI/Types';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import styles from './ModalRateItem.module.scss';
interface ReviewRateItemType {
  icon: IconNames;
  title: string;
  rate: number;
}
const ModalRateItem = ({
  icon,
  title,
  rate
}: ReviewRateItemType) => {
  return <Box className={styles['modal-item-rate']} data-sentry-element="Box" data-sentry-component="ModalRateItem" data-sentry-source-file="ModalRateItem.tsx">
      <Box className={styles['rate-item-title-wrapper']} data-sentry-element="Box" data-sentry-source-file="ModalRateItem.tsx">
        <Icon name={icon} type={'highEmphasis'} size="large" data-sentry-element="Icon" data-sentry-source-file="ModalRateItem.tsx" />
        <Typography variant="bodyS" data-sentry-element="Typography" data-sentry-source-file="ModalRateItem.tsx">{title}</Typography>
      </Box>
      <Typography variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="ModalRateItem.tsx">
        {rate}{' '}
        <Typography variant="bodyS" color="neutral_main" data-sentry-element="Typography" data-sentry-source-file="ModalRateItem.tsx">
          از5
        </Typography>
      </Typography>
    </Box>;
};
export default ModalRateItem;